(function($) {
	'use strict';
	$.fn.Collection__Delete = function() {
		this.each(function() {

			/*
			 * Action: Delete Collection
			 */
			var $self = $(this),
				collection_id = $self.data('cid');

			// Listener
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

	      // Add confirm
	      var confirmed = confirm( Front.translations.confirm_delete );
	      if (confirmed) {

					// Track in Google
					$.Globals.track_event( 'Collection Deleted' );

					// Remove it
					$.Globals.ajax( 'scspaces_collection_delete', { 'cid' : collection_id }, function(){

						// If this it an edit collection page
						if( $.Body.hasClass( 'collection-edit' ) ) {

							// We don't have that collections anymore.  Go to my collections
							window.location = Front.my_collections_url;

						} else { // <= if collections grid page

							// Remove the collection if a grid exists
							$('#grid-list > .collection-' + collection_id ).fadeOut( function() {
								var $grid_item = $(this);
								setTimeout( function() {

									$grid_item.remove();

								}, 200 );
							});

						}

					});

	      }

			});

		});
		return this;
	};
}(jQuery));
